import {Mapper} from '@s-ui/domain'

export default class PriceRawDataToPriceVOMapper extends Mapper {
  constructor({valueObject}) {
    super()
    this._valueObject = valueObject
  }

  map = ({price: {value, currency}}) => {
    const fromIntegerToDecimal = value => value / 100
    return this._valueObject({
      value,
      amountLabelValue: fromIntegerToDecimal(value),
      currency
    })
  }
}
